module.exports = __webpack_public_path__ + "img/P150T_weapon_112.b6a27e24.png";